import { DefaultLayout } from "components/Layouts";
import { LayoutProps } from "components/Layouts/Layout.types";
import { selectUserProfile } from "pages/User/userSelectors";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const PublicRoute: FC<{
  children: React.ReactNode;
  layout?: FC<LayoutProps>;
  layoutProps?: { bgColor?: string; lgColumns?: string };
  exact?: boolean;
}> = ({ children, layout: ComponentLayout, layoutProps }) => {
  const Layout = ComponentLayout || DefaultLayout;
  const layoutStyles = {
    lgColumns: layoutProps?.lgColumns || "w-full",
    bgColor: layoutProps?.bgColor || "bg-gray-100"
  };

  const user = useSelector(selectUserProfile);

  if (user) {
    return <Navigate to="/" />;
  }

  return <Layout {...layoutStyles}>{children}</Layout>;
};
